module.exports = __webpack_public_path__ + "img/itx-file-type-txt.81118127.svg";